import { Routes, Route, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

import BannerLogos from "./components/BannerLogos";
import CookieBanner from "./components/CookieBanner";

//Importar páginas visibles para todo el mundo
import LandingPage from "./pages/LandingPage";
import RegistroEnviado from "./pages/RegistroEnviado";
import UsuarioRechazado from "./pages/UsuarioRechazado";
import Registro from "./pages/auth/Registro";

import AvisoLegal from "./pages/AvisoLegal";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad";
import TerminosCondiciones from "./pages/TerminosCondiciones";
import PoliticaCookies from "./pages/PoliticaCookies";
import Accesibilidad from "./pages/Accesibilidad";
import MapaWeb from "./pages/MapaWeb";

//Importar páginas para técnicos y ciudadanos
import OfertaEmpleo from "./pages/user/OfertaEmpleo";
import OfertaFormacion from "./pages/user/OfertaFormacion";
import Recurso from "./pages/user/Recurso";
import RecursoSocial from "./pages/user/RecursoSocial";
import ServicioAyuntamiento from "./pages/user/ServicioAyuntamiento";

//Importar páginas para técnicos
import AdminDashboard from "./pages/admin/Dashboard";
import UsuariosAdmin from "./pages/admin/Usuarios";
import HistoricoCitas from "./pages/admin/HistoricoCitas";
import Expediente from "./pages/admin/Expediente";
import NuevoUsuario from "./pages/admin/NuevoUsuario";
import AdminAgenda from "./pages/admin/Agenda";
import AdminEmpleo from "./pages/admin/Empleo";
import AdminFormacion from "./pages/admin/Formacion";
import AdminRecursos from "./pages/admin/Recursos";
import AdminSocial from "./pages/admin/Social";
import Programas from "./pages/admin/Programas";
import NuevoEmpleo from "./pages/admin/NuevoEmpleo";
import NuevaFormacion from "./pages/admin/NuevaFormacion";
import NuevoRecursoInteres from "./pages/admin/NuevoRecursoInteres";
import NuevoRecursoSocial from "./pages/admin/NuevoRecursoSocial";
import NuevoServicioSocial from "./pages/admin/NuevoServicioSocial";
import AdminChat from "./pages/admin/Chat";
//import NuevoPrograma from "./pages/admin/NuevoPrograma";
import AdminEstadisticas from "./pages/admin/Estadisticas";
import AdminPerfil from "./pages/admin/Perfil";
import AdminMensajes from "./pages/admin/Mensajes";
import AdminNotificaciones from "./pages/admin/Notificaciones";

//Importar páginas para usuarios
import UserDashboard from "./pages/user/Dashboard";
import Curriculum from "./pages/user/Curriculum";
import Documentos from "./pages/user/Documentos";
import UserNotificaciones from "./pages/user/Notificaciones";
import UserEmpleo from "./pages/user/Empleo";
import UserFormacion from "./pages/user/Formacion";
import UserRecursos from "./pages/user/Recursos";
import UserPerfil from "./pages/user/Perfil";
import UserSocial from "./pages/user/Social";
import UserContacto from "./pages/user/Contacto";

import NotFound from "./pages/NotFound";
import PrivateRoute from "./components/PrivateRoute";
import { EliminarCuenta } from "./pages/EliminarCuenta";
import LegalLayout from "./components/LegalLayout";

function App() {
  const location = useLocation();
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mainContentStyle = {
    minHeight: `${windowHeight}px`,
    display: "flex",
    flexDirection: "column",
  };

  return (
    <div style={mainContentStyle}>
      <div style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          <Route path="/registro" element={<Registro />} />
          <Route path="/registro-enviado" element={<RegistroEnviado />} />
          <Route path="/usuario-rechazado" element={<UsuarioRechazado />} />
          <Route path="/aviso-legal" element={<LegalLayout title="Aviso legal"><AvisoLegal /></LegalLayout>} />
          <Route path="/politica-privacidad-app" element={<LegalLayout title="Política de privacidad"><PoliticaPrivacidad /></LegalLayout>} />
          <Route path="/app-eliminar-cuenta" element={<EliminarCuenta/>} />
          <Route
            path="/terminos-condiciones"
            element={<LegalLayout title="Términos y condiciones de uso"><TerminosCondiciones /></LegalLayout>}
          />
          <Route path="/politica-cookies" element={<PoliticaCookies />} />
          <Route path="/accesibilidad" element={<Accesibilidad />} />
          <Route path="/mapa-web" element={<MapaWeb />} />
          <Route path="*" element={<NotFound />} />

          {/* Rutas para técnicos y ciudadanos*/}
          <Route
            path="/recurso-social/:id"
            element={
              <PrivateRoute
                allowedRoles={[
                  "ciudadano",
                  "administrador",
                  "tecnico-1",
                  "tecnico-2",
                ]}
              >
                <RecursoSocial />
              </PrivateRoute>
            }
          />
          <Route
            path="/servicio-ayuntamiento/:id"
            element={
              <PrivateRoute
                allowedRoles={[
                  "ciudadano",
                  "administrador",
                  "tecnico-1",
                  "tecnico-2",
                ]}
              >
                <ServicioAyuntamiento />
              </PrivateRoute>
            }
          />
          <Route
            path="/empleo/:id"
            element={
              <PrivateRoute
                allowedRoles={[
                  "ciudadano",
                  "administrador",
                  "tecnico-1",
                  "tecnico-2",
                ]}
              >
                <OfertaEmpleo />
              </PrivateRoute>
            }
          />
          <Route
            path="/formacion/:id"
            element={
              <PrivateRoute
                allowedRoles={[
                  "ciudadano",
                  "administrador",
                  "tecnico-1",
                  "tecnico-2",
                ]}
              >
                <OfertaFormacion />
              </PrivateRoute>
            }
          />
          <Route
            path="/recurso/:id"
            element={
              <PrivateRoute
                allowedRoles={[
                  "ciudadano",
                  "administrador",
                  "tecnico-1",
                  "tecnico-2",
                ]}
              >
                <Recurso />
              </PrivateRoute>
            }
          />

          {/* Rutas protegidas por rol de técnico*/}
          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <UsuariosAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/historico-citas"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <HistoricoCitas />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/usuario/:id"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <Expediente />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nuevo-usuario"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <NuevoUsuario />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/agenda"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminAgenda />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/empleo"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminEmpleo />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/formacion"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminFormacion />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/recursos"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminRecursos />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nuevo-empleo"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevoEmpleo />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nuevo-empleo/:id"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevoEmpleo />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nueva-formacion"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevaFormacion />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nueva-formacion/:id"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevaFormacion />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nuevo-recurso-interes"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevoRecursoInteres />
              </PrivateRoute>
            }
          />
          {/* Edita el recurso */}
          <Route
            path="/admin/nuevo-recurso-interes/:id"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevoRecursoInteres />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/listado-programas"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <Programas />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/social"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminSocial />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nuevo-recurso-social"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevoRecursoSocial />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nuevo-recurso-social/:id"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevoRecursoSocial />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nuevo-servicio-social"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevoServicioSocial />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/nuevo-servicio-social/:name"
            element={
              <PrivateRoute allowedRoles={["administrador", "tecnico-1"]}>
                <NuevoServicioSocial />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/estadisticas"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminEstadisticas />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/perfil"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminPerfil />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/chat"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminChat />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/mensajes"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminMensajes />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/notificaciones"
            element={
              <PrivateRoute
                allowedRoles={["administrador", "tecnico-1", "tecnico-2"]}
              >
                <AdminNotificaciones />
              </PrivateRoute>
            }
          />

          {/* Rutas protegidas por rol de ciudadano*/}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <UserDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/curriculum"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <Curriculum />
              </PrivateRoute>
            }
          />
          <Route
            path="/documentos"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <Documentos />
              </PrivateRoute>
            }
          />
          <Route
            path="/empleo"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <UserEmpleo />
              </PrivateRoute>
            }
          />
          <Route
            path="/formacion"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <UserFormacion />
              </PrivateRoute>
            }
          />
          <Route
            path="/recursos"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <UserRecursos />
              </PrivateRoute>
            }
          />
          <Route
            path="/social"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <UserSocial />
              </PrivateRoute>
            }
          />
          <Route
            path="/contacto"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <UserContacto />
              </PrivateRoute>
            }
          />
          <Route
            path="/perfil"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <UserPerfil />
              </PrivateRoute>
            }
          />
          <Route
            path="/notificaciones"
            element={
              <PrivateRoute allowedRoles={["ciudadano"]}>
                <UserNotificaciones />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>

      {/* Mostrar BannerLogos excepto en /registro */}
      {!["/registro", "/admin/chat"].includes(location.pathname) && (
        <BannerLogos />
      )}
      <CookieBanner />
    </div>
  );
}

export default App;
